export default __webpack_public_path__ + "static/media/hera_icon.df79605e.svg";